module.exports = __webpack_public_path__ + "static/media/team2.b50ba903.jpg";